import { render, staticRenderFns } from "./LazyCascaderNew.vue?vue&type=template&id=230d8789&scoped=true&"
import script from "./LazyCascaderNew.vue?vue&type=script&lang=js&"
export * from "./LazyCascaderNew.vue?vue&type=script&lang=js&"
import style0 from "./LazyCascaderNew.vue?vue&type=style&index=0&id=230d8789&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230d8789",
  null
  
)

export default component.exports